import Cookies from 'js-cookie';
import { appKeysConfig } from '@shared/@controls/constants/common';

const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

export const Base64 = {
  btoa: (input: string = '') => {
    const str = input;
    let output = '';

    for (
      let block = 0, charCode, i = 0, map = chars;
      str.charAt(i | 0) || ((map = '='), i % 1);
      output += map.charAt(63 & (block >> (8 - (i % 1) * 8)))
    ) {
      charCode = str.charCodeAt((i += 3 / 4));

      if (charCode > 0xff) {
        throw new Error(
          "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.",
        );
      }

      block = (block << 8) | charCode;
    }

    return output;
  },

  atob: (input: string = '') => {
    const str = input.replace(/=+$/, '');
    let output = '';

    if (str.length % 4 == 1) {
      throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    }
    for (
      let bc = 0, bs = 0, buffer, i = 0;
      (buffer = str.charAt(i++));
      ~buffer && ((bs = bc % 4 ? bs * 64 + buffer : buffer), bc++ % 4)
        ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
        : 0
    ) {
      buffer = chars.indexOf(buffer);
    }

    return output;
  },
};

// export function encodeCookieValue(value: any, secrets: string[]): string {
//   let encoded = encodeData(value);

//   if (secrets.length > 0) {
//     encoded = sign(encoded, secrets[0]);
//   }

//   return encoded;
// }

// export function decodeCookieValue(value: string, secrets: string[]): any {
//   console.log(secrets);

//   if (secrets?.length > 0) {
//     for (const secret of secrets) {
//       const unsignedValue = unsign(value, secret);
//       if (unsignedValue !== false) {
//         return decodeData(unsignedValue);
//       }
//     }

//     return null;
//   }

//   return decodeData(value);
// }

export function encodeCookie(value: any): string {
  return Base64.btoa(JSON.stringify(value));
}

export function decodeCookie(value: string): any {
  try {
    return JSON.parse(Base64.atob(value));
  } catch (error) {
    return {};
  }
}
export function getTokenAtClient(): string {
  try {
    // Get the TOKEN cookie (now contains raw JWT, URL-encoded)
    const token = Cookies.get(appKeysConfig.TOKEN);
    // console.log(
    //   '[getTokenAtClient] TOKEN cookie:',
    //   token ? `${token.substring(0, 20)}...` : 'NOT FOUND',
    // );

    if (!token) {
      // console.log('[getTokenAtClient] No token found');
      return '';
    }

    try {
      // Token is URL-encoded in the cookie, decode it
      const decoded = decodeURIComponent(token);
      console.log('[getTokenAtClient] Token decoded successfully');
      return decoded;
    } catch (err) {
      // If decoding fails, return raw token
      console.log('[getTokenAtClient] Using raw token (decode failed)');
      return token;
    }
  } catch (error) {
    console.error('[getTokenAtClient] Error:', error);
    return '';
  }
}

export function getAllocationAtClient(): string {
  try {
    const allocationId = Cookies.get(appKeysConfig.ALLOCATION);
    return allocationId ?? '';
  } catch (error) {
    return '';
  }
}
